import { render, staticRenderFns } from "./TogglePublicViewBtn.vue?vue&type=template&id=5aa59047&scoped=true&"
import script from "./TogglePublicViewBtn.vue?vue&type=script&lang=js&"
export * from "./TogglePublicViewBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa59047",
  null
  
)

export default component.exports